/**
 * Defines the possible statuses for customer monthly statistics.
 */
export enum CustomerMonthlyStatisticStatusModel {
	/**
	 * This status indicates that the process is ongoing and has not yet been completed.
	 */
	Calculating = 1,
	/**
	 * This status signifies that all necessary computations are finished.
	 */
	Completed = 2
}
